const configs = {
  currencySymbol: '',
  showOnlyActiveGameBoxTag: true,
  broadcastGBMessage: true,
};

export default configs;
